import { AirplaneMarkerIcon } from './AirplaneMarkerIcon';

/**
 * author: Colton Wiscombe
 * id 792432E4-3913-4118-80E9-C8F348DEFBA4
 * name airplane-marker
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/airplane-marker.svg
 * tags
 * - Transportation + Flying 
 * - Navigation 
 */
export const AirplaneLocationIcon = AirplaneMarkerIcon;
export default AirplaneLocationIcon